"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _recompose = require("@shakacode/recompose");
var _default = _recompose.renderNothing;
exports.default = _default;